import { render, staticRenderFns } from "./autoform.vue?vue&type=template&id=786b0844&"
import script from "./autoform.vue?vue&type=script&lang=js&"
export * from "./autoform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports